import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { ExtractModes } from "../../../LeftPanel/ExtractAdd/redux/Types";
import { Button } from "../../../Common/UI/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";
import "../Style.scss";

interface ISaveExtractViewProps {
  /**
   * Reverts the changes when clicking cancel
   */
  cancel: () => void;
  /**
   * Flag value disable save button
   */
  isDisabled: boolean;
  /**
   * Extract mode of either create,edit or view
   */
  mode: ExtractModes;
  /**
   * On clicking create or update button to save extract
   */
  onSubmit: () => void;
}

/**
 * Returns the save extract footer content
 */
export const SaveExtractDetailView = (props: ISaveExtractViewProps): JSX.Element => {
  const { cancel, isDisabled, onSubmit } = props;
  const { t: translate } = useTranslation();

  return (
    <div className="ebt-schedule__footer">
      <Button
        data-testid="ebt-update__btn"
        variant={ButtonVariantType.FILLED}
        disabled={isDisabled}
        onClick={onSubmit}
        className="ebt-extract-update"
      >
        {translate("Button.Update")}
      </Button>
      <Button
        data-testid="ebt-update__cancel"
        borderless={true}
        onClick={cancel}
      >
        {translate("Button.Cancel")}
      </Button>
    </div>
  );
};
